<template>
  <b-tabs
    ref="businessSettingTabBar"
    lazy
    :vertical="verticalTabBar.status"
    :nav-wrapper-class="verticalTabBar.wrapper"
  >
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'business-profile-manage').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="UsersIcon" />
        <span>Business Profile</span>
      </template>
      <b-card>
        <BusinessProfile />
      </b-card>
    </b-tab>
    <b-tab
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="ToolIcon" />
        <span>General Settings</span>
      </template>
      <b-card>
        <General />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'show-waybill-setting').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="FileMinusIcon" />
        <span>Waybill Management</span>
      </template>
      <WaybillManagement />
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'edit-order-setting').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="BoxIcon" />
        <span>Orders</span>
      </template>
      <b-card>
        <Orders />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'edit-finance-status-setting').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="OctagonIcon" />
        <span>Statuses</span>
      </template>
      <b-card>
        <Statuses />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'edit-waybill-layout').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="PrinterIcon" />
        <span>Print Layouts</span>
      </template>
      <b-card>
        <Print />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'edit-finance-setting').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="DollarSignIcon" />
        <span>Finance</span>
      </template>
      <b-card>
        <Finance />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'view-tax').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="PercentIcon" />
        <span>Tax Settings</span>
      </template>
      <b-card>
        <Tax />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'tracking-page-image' || permission === 'show-edit-additional-tracking-details' || permission === 'view-tracking-templates' || permission === 'create-tracking-templates' || permission === 'assign-merchants-to-tracking-template').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="MonitorIcon" />
        <span>Tracking Settings</span>
      </template>
      <b-card>
        <TrackingSettings />
      </b-card>
    </b-tab>
    <!--Merchant Settings-->
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'show-merchant-setting').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="BriefcaseIcon" />
        <span>Merchant Settings</span>
      </template>
      <Merchant />
    </b-tab>
    <!--Approval Settings-->
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'view-profile-update-approval').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="CheckCircleIcon" />
        <span>Approval Settings</span>
      </template>
      <b-card>
        <ApprovalSetting />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => ( permission === 'web-theme-setting' || permission === 'mobile-theme-setting' )).length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="ApertureIcon" />
        <span>Theme Settings</span>
      </template>
      <b-card>
        <ThemeSetting />
      </b-card>
    </b-tab>
    <b-tab
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="CheckCircleIcon" />
        <span>Terms And Condition</span>
      </template>
      <TermsAndCondition />
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => ( permission === 'create-merchant-notification' || permission === 'edit-status-notification' || permission === 'edit-reminder-notification' || permission === 'edit-finance-notification' || permission === 'edit-other-notification' )).length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="BellIcon" />
        <span>Notification</span>
      </template>
      <b-card>
        <Notification />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'password-rest').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="LockIcon" />
        <span>Security & Privacy Settings</span>
      </template>
      <b-card>
        <ChangePassword />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'password-rest').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="KeyIcon" />
        <span>Auth Token Settings</span>
      </template>
      <b-card>
        <AuthTokenSetting />
      </b-card>
    </b-tab>
    <b-tab
      v-if="store.getters.permissions.filter(permission => permission === 'show-payment-setting').length > 0"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="CreditCardIcon" />
        <span>Payment Method</span>
      </template>
      <PaymentGateway />
    </b-tab>
    <b-tab
      v-if="aiModuleEnabled && (store.getters.permissions.filter(permission => permission === 'show-ai-setting').length > 0)"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="StarIcon" />
        <span>AI Settings</span>
      </template>
      <b-card>
        <AI />
      </b-card>
    </b-tab>
    <b-tab
      v-if="customerDataSecurityModuleEnabled && (store.getters.permissions.filter(permission => permission === 'show-security-setting').length > 0)"
      title-item-class="d-flex justify-content-start"
    >
      <template #title>
        <feather-icon icon="EyeIcon" />
        <span>Customer Details Settings</span>
      </template>
      <b-card>
        <CustomerDetailsSetting />
      </b-card>
    </b-tab>
  </b-tabs>
</template>

<script>
import {
  BTabs, BTab, BCard,
} from 'bootstrap-vue'
import {
  mapGetters,
} from 'vuex'
import BusinessProfile from '@/components/setting/BusinessProfile.vue'
import Orders from '@/components/setting/Orders.vue'
import WaybillManagement from '@/components/setting/WaybillManagement.vue'
import Statuses from '@/components/setting/Statuses.vue'
import Finance from '@/components/setting/Finance.vue'
import PaymentGateway from '@/components/setting/PaymentGateway.vue'
import Print from '@/components/setting/Print.vue'
import Notification from '@/components/setting/Notification.vue'
import ChangePassword from '@/components/setting/ChangePassword.vue'
import AuthTokenSetting from '@/components/setting/AuthTokenSetting.vue'
import General from '@/components/setting/General.vue'
import Tax from '@/components/setting/Tax.vue'
import AI from '@/components/setting/AISetting.vue'
import CustomerDetailsSetting from '@/components/setting/CustomerDetailsSetting.vue'
import store from '@/store'
import { $themeBreakpoints } from '@themeConfig'
import TrackingSettings from '@/components/setting/TrackingSettings.vue'
import Merchant from '@/components/setting/Merchant.vue'
import ThemeSetting from '@/components/setting/ThemeSetting.vue'
import ApprovalSetting from '@/components/setting/ApprovalSetting.vue'
import TermsAndCondition from '@/components/setting/TermsAndCondition.vue'

export default {
  components: {
    Notification,
    BusinessProfile,
    WaybillManagement,
    ChangePassword,
    AuthTokenSetting,
    Finance,
    Print,
    Orders,
    Statuses,
    General,
    Tax,
    TrackingSettings,
    Merchant,
    ThemeSetting,
    BTabs,
    BTab,
    BCard,
    ApprovalSetting,
    TermsAndCondition,
    PaymentGateway,
    AI,
    CustomerDetailsSetting,
  },
  data() {
    return {
      store,
      aiModuleEnabled: false,
      customerDataSecurityModuleEnabled: false,
    }
  },
  computed: {
    verticalTabBar() {
      if (this.$store.state.app.windowWidth > $themeBreakpoints.lg) {
        return {
          status: true,
          wrapper: 'nav-vertical',
        }
      }
      return {
        status: false,
        wrapper: 'nav-horizontal',
      }
    },
    ...mapGetters(['currentUser']),
  },
  mounted() {
    this.fetchModules()
    // eslint-disable-next-line no-underscore-dangle
    this.__preserveTabOnRefresh('businessSettingTabBar', 'businessSettingTabIndex')
  },
  methods: {
    async fetchModules() {
      try {
        const data = JSON.parse(localStorage.getItem('module_data'))
        const aiSettingModule = data.find(n => n.name === 'AI Setting')
        this.aiModuleEnabled = aiSettingModule ? aiSettingModule.is_active : false
        const customerDataSecurityModule = data.find(n => n.name === 'Customer Data Security Module')
        this.customerDataSecurityModuleEnabled = customerDataSecurityModule ? customerDataSecurityModule.is_active : false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>
